import { AsiaType, AsiaTypeId } from 'asia-common/src/vtj/koodisto/asia-enums'
import { isValueInEnum } from 'todistukset-common/src/vtj/type-guards'

enum CertificateTypes {
  ASUINPAIKKATODISTUS = 'asuinpaikkatodistus',
  ELOSSAOLOTODISTUS = 'elossaolotodistus',
  AVIOLIITTOTODISTUS = 'avioliittotodistus',
  SIVIILISAATYTODISTUS = 'siviilisaatytodistus',
  SYNTYMATODISTUS = 'syntymatodistus',
  AETTODISTUS = 'aettodistus',
  UAETTODISTUS = 'uaettodistus',
  TODISTUSASUMISTIEDOILLA = 'todistusasumistiedoilla',
  TODISTUSHENKILOJAPERHESUHDETIEDOILLA = 'todistushenkilojaperhesuhdetiedoilla',
  TODISTUSKUOLEMASTA = 'todistuskuolemasta',
}

export type AsiointipalveluTodistusType =
  | CertificateTypes.ASUINPAIKKATODISTUS
  | CertificateTypes.ELOSSAOLOTODISTUS
  | CertificateTypes.AVIOLIITTOTODISTUS
  | CertificateTypes.SIVIILISAATYTODISTUS
  | CertificateTypes.SYNTYMATODISTUS
  | CertificateTypes.AETTODISTUS
  | CertificateTypes.UAETTODISTUS

export type VtjOteTodistusType =
  | CertificateTypes.ASUINPAIKKATODISTUS
  | CertificateTypes.ELOSSAOLOTODISTUS
  | CertificateTypes.AVIOLIITTOTODISTUS
  | CertificateTypes.SIVIILISAATYTODISTUS
  | CertificateTypes.SYNTYMATODISTUS

const vtjOteTodistukset = [
  CertificateTypes.ASUINPAIKKATODISTUS,
  CertificateTypes.ELOSSAOLOTODISTUS,
  CertificateTypes.AVIOLIITTOTODISTUS,
  CertificateTypes.SIVIILISAATYTODISTUS,
  CertificateTypes.SYNTYMATODISTUS,
]

export const elsaVtjOteTodistukset = [
  AsiaType.ASUINPAIKKATODISTUS,
  AsiaType.ELOSSAOLOTODISTUS,
  AsiaType.AVIOLIITTOTODISTUS,
  AsiaType.SIVIILISAATYTODISTUS,
  AsiaType.SYNTYMATODISTUS,
]

export const getCertificateTypeFromAsiaType = (
  asiaType: AsiaTypeId
): CertificateTypes => {
  switch (asiaType) {
    case AsiaType.ASUINPAIKKATODISTUS:
      return CertificateTypes.ASUINPAIKKATODISTUS
    case AsiaType.ELOSSAOLOTODISTUS:
      return CertificateTypes.ELOSSAOLOTODISTUS
    case AsiaType.AVIOLIITTOTODISTUS:
      return CertificateTypes.AVIOLIITTOTODISTUS
    case AsiaType.SIVIILISAATYTODISTUS:
      return CertificateTypes.SIVIILISAATYTODISTUS
    case AsiaType.SYNTYMATODISTUS:
      return CertificateTypes.SYNTYMATODISTUS
    case AsiaType.AVIOLIITON_ESTEIDEN_TUTKINTA:
      return CertificateTypes.AETTODISTUS
    case AsiaType.TODISTUS_OIKEUDESTA_MENNA_AVIOLIITTOON_ULKOMAILLA:
      return CertificateTypes.UAETTODISTUS
    case AsiaType.TODISTUS_ASUMISTIEDOISTA:
      return CertificateTypes.TODISTUSASUMISTIEDOILLA
    case AsiaType.TODISTUS_HENKILO_JA_PERHESUHDETIEDOISTA:
      return CertificateTypes.TODISTUSHENKILOJAPERHESUHDETIEDOILLA
    case AsiaType.TODISTUS_KUOLEMASTA:
      return CertificateTypes.TODISTUSKUOLEMASTA
    default:
      throw new Error(`Unsupported AsiaTypeId: ${asiaType}`)
  }
}

export const isVtjOteTodistus = (value: unknown): value is VtjOteTodistusType =>
  isValueInEnum(value, CertificateTypes) && vtjOteTodistukset.includes(value)

export default CertificateTypes
